export const Settings = () => {
  return (
    <div className="my-account-content account-order">
      <div className="">
        <h4 className="title-right">Message Preferences</h4>
        <div className="row">
          <div className="col-md-12">
            <div className="noti">
              <b>
                Order related notifications can not bedisabled as they
                arecritical to provide service.
              </b>
            </div>
          </div>
          <div className="col-md-12">
            <div className="noti d-flex mt-3 justify-content-center align-items-center">
              <div className="w-50">
                <div className="form-check form-switch">
                  <input
                    checked
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="flexSwitchCheckDefault"
                    readOnly
                  />
                  <label
                    className="form-check-label"
                    htmlFor="flexSwitchCheckDefault"
                  >
                    Recommendations and Reminders
                  </label>
                </div>
              </div>
              <div className="text-start">
                Keep this on to receive offer recommendations and timely
                reminders based on your interests.
              </div>
            </div>
          </div>
        </div>

        <h4 className="title-right mt-5">Delete Account</h4>
        <p>
          Your Account will be deleted by pressing the Delete Account Button
        </p>
        <a
          className="btn-prime mt-3"
          // href="#deleteAccount"
          // data-bs-toggle="modal"
        >
          Delete Account
        </a>
      </div>
    </div>
  );
};
